import MyWorkspaces from './my-workspaces';

export default MyWorkspaces;
